import { gql } from '__generated__';

export default gql(`
  query GetPortal {
    session {
      id
      user {
        id
        first_name
        last_name
        full_name
        email
        locale
        sport_type
        authenticator_available
        authenticator_enabled
        registration_summaries {
          id
          view_token
          deletable_by_participant
          registrations_count
          review {
            id
            rating
            aspects
            comment
            created_at
          }
          can_add_review
          participant {
            id
            first_name
            full_name
          }
          event {
            id
            title
            start_date
            end_date
            checkout_url
            active
            review_average_rating
            reviews {
              total
            }
            project {
              id
              organisation_name
              timezone
            }
            logo {
              id
              url
            }
          }
        }
        participants {
          id
          available_mail_permissions {
            id
          }
          project {
            id
            organisation_name
          }
        }
        project_memberships {
          id
          permissions
          deletable
          project {
            id
            organisation_name
          }
        }
      }
    }
  }
`);
